<template>
  <div class="btn-wraper" :style="{background: btnItem.color, border: btnItem.border}" v-show="show">
    <input type="button" :style="{color: btnItem.font_color}" :value="btnItem.title" @click="go" />
  </div>
</template>
<script>
import { ends } from "../../tools/constant";
import { getEnd } from "../../tools/utils";
export default {
  props: ["btnItem", "omegaItem"],
  data() {
    return {
      ends,
      resultConfig: {}
    };
  },
  computed: {
    show() {
      let end = getEnd();
      let d = this.btnItem.display;
      if (!d) {
        return true;
      }
      return d.indexOf(end) > -1;
    },
    // omegaItem() {
    //   let up = new URLSearchParams(window.location.search);
    //   return{
    //     country: up.get('location_country'),
    //     o_id: up.get("oid") || Omega.getOmgid(),
    //     channel_id: up.get("channel")
    //   }
    // },
  },
  methods: {
    go() {
      // 下载按钮点击埋点
      try {
        Omega.trackEvent("ibt_register_review_result_download_button_ck", "", this.omegaItem);
      } catch (e) {}

      let { ios, android } = this.btnItem.to;
      if (this.btnItem.bridge && this.btnItem.bridge === 'openPage') {
        Fusion.openPage && Fusion.openPage({
          url: android || ios,
          target: this.btnItem.target,
          browser: !!Number(this.btnItem.browser)
        });
        return;
      }
      if (this.ends.isFleetApp || this.ends.isFleet) {
        const url = android || ios;
        const module = Fusion.loadModule("newPageModule");
        this.ends.inApp && module.openNewPage({
          url,
          back_to_fleethome: 1,
          tab_index: 2
        });
        !this.ends.inApp && location.replace(url);
        return;
      }
      if (this.ends.isPC) {
        window.open(android, "_blank");
      } else if (this.ends.isIOS) {
        window.open(ios, "_blank");
      } else if (this.ends.isAndroid) {
        window.open(android, "_blank");
      } else {
        window.open(android, "_blank");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-wraper {
  width: 100%;
  height: 1.08rem;
  line-height: 1.08rem;
  border-radius: 0.04rem;
  border: 2px solid #666666;
  font-size: 0.36rem;
  font-weight: 500;
  background: #ffffff;
  color: #666666;
  text-align: center;
  box-sizing: border-box;
  input {
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
}
</style>
